<template>
  <div class="pulsar" />
</template>

<style scoped>
.pulsar {
  display: inline-block;
  --uib-size: 25px;
  --uib-speed: 3s;
  --uib-color: white;
  position: relative;
  height: var(--uib-size);
  width: var(--uib-size);
}

.pulsar::before,
.pulsar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-color: var(--uib-color);
  animation: pulse9173412 var(--uib-speed) ease-in-out infinite;
  transform: scale(0);
}

.pulsar::after {
  animation-delay: calc(var(--uib-speed) / -2);
}

@keyframes pulse9173412 {
  0%,
  100% {
    transform: scale(0);
    opacity: 1;
  }

  50% {
    transform: scale(1);
    opacity: 0.25;
  }
}
</style>